import { render, staticRenderFns } from "./AddPPage.vue?vue&type=template&id=6dc39cc3&scoped=true&"
import script from "./AddPPage.vue?vue&type=script&lang=js&"
export * from "./AddPPage.vue?vue&type=script&lang=js&"
import style0 from "./AddPPage.vue?vue&type=style&index=0&id=6dc39cc3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc39cc3",
  null
  
)

export default component.exports